const $ = require("jquery");
const ko = require("knockout");
const ChatViewModel = require("./chat.vm");
require("../../scripts/custom-ko-bindings");

$(function () {
    $(".ws-chat").each(function () {
        const $this = $(this),
            viewModel = new ChatViewModel($this);

        ko.applyBindings(viewModel, this);
    });
});